import { render, staticRenderFns } from "./PaintingsSliderContainer.vue?vue&type=template&id=5df6458b&scoped=true&"
import script from "./PaintingsSliderContainer.vue?vue&type=script&lang=js&"
export * from "./PaintingsSliderContainer.vue?vue&type=script&lang=js&"
import style0 from "./PaintingsSliderContainer.vue?vue&type=style&index=0&id=5df6458b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df6458b",
  null
  
)

export default component.exports